import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function PartnerWithUs() {
  return (
    <StaticPage title="Partner With Us" subtitle="Join Australia's fastest-growing student accommodation network.">
      <Section title="Why Partner with RentalX">
        <p>Whether you're a university, real estate agency, student services provider, or relocation company, RentalX offers partnership opportunities that create value for your students or clients while expanding your reach.</p>
      </Section>

      <Section title="Partnership Types">
        <CardGrid items={[
          { title: 'University Partnerships', desc: 'Integrate RentalX into your student portal so new students can find verified housing before they arrive.' },
          { title: 'Real Estate Agency Partners', desc: 'List your student-friendly properties on RentalX and reach thousands of active students per month.' },
          { title: 'Relocation & Visa Services', desc: 'Bundle housing search with your existing services to deliver a complete arrival package.' },
          { title: 'Student Associations', desc: 'Co-brand content and resources to help your members find safe and affordable housing.' },
        ]} />
      </Section>

      <Section title="Benefits">
        <ul className="list-disc list-inside space-y-2">
          <li>Co-branded landing pages and referral tracking</li>
          <li>Access to the RentalX Partner API</li>
          <li>Dedicated account manager</li>
          <li>Priority listing placement for agency partners</li>
          <li>Monthly reporting and analytics dashboard</li>
        </ul>
      </Section>

      <Section title="Get In Touch">
        <p>Reach out to our partnerships team at <strong>partners@rentalx.com.au</strong> or fill out the inquiry form below.</p>
        <div className="mt-4 p-6 bg-sky-50 rounded-xl border border-sky-100">
          <p className="text-sm text-gray-500">Partnership inquiry form — email us at <strong>partners@rentalx.com.au</strong> and we'll be in touch within 2 business days.</p>
        </div>
      </Section>
    </StaticPage>
  );
}
